<template>
	<div>
		<el-form ref="ruleForm" label-width="120px" class="demo-ruleForm">
			<el-form-item label="店铺名">
				<el-input size="small" v-model="infos.shop_name" ></el-input>
			</el-form-item>
			<el-form-item label="操作" prop="status">
				<el-select v-model="infos.status">
				      <el-option label="待处理" :value="0"></el-option>
				      <el-option label="已同意" :value="1"></el-option>
					  <el-option label="已拒绝" :value="2"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="操作" prop="types">
				<el-select v-model="infos.types">
				      <el-option label="关闭" :value="0"></el-option>
				      <el-option label="独立跟单" :value="1"></el-option>
					  <el-option label="混合跟单" :value="2"></el-option>
				</el-select>
			</el-form-item>
			
			<el-form-item>
				<el-button type="primary" @click="submitApi()">确认操作</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		props:['Info'],
	    data() {
			return {
				infos:'',
	      };
	    },
		created() {
			this.infos = JSON.parse(JSON.stringify(this.Info));
		},
	    methods: {
			submitApi(){
				let _this = this;
				
				const loading = this.$loading({
						lock: true,
						text: '处理中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post("/Virtuals/actionVirtualApply", {...this.infos}).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						_this.$message({
							 message: '操作成功~',
							 type: 'success',
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			}
	    }
	  }
</script>

<style scoped>
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    min-width: 80px;
	    height: 80px;
	    line-height: 80px;
	    text-align: center;
		border: solid 1px #dcdcdc;
	  }
	  .avatar {
	    min-width: 80px;
	    height: 80px;
	    display: block;
	  }
</style>